const OUTBOUND_TAG_PREFIX = "OUTBOUND_";

export function hasOutboundSessionTag(sessionTags?: string[]): boolean {
    return (sessionTags || []).some(tag => tag.startsWith(OUTBOUND_TAG_PREFIX));
}
